/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import Icon from "components/common_components/Icon";

function MenuItem({ label, path, icon, selected, onClick }) {
    const history = useHistory();

    return (
        <div
            className={clsx("nav-item", {
                "nav-item--active": selected,
            })}
            disabled={!path}
            selected={selected}
            onClick={() => {
                onClick?.();
                history.push(path);
            }}
        >
            <div className="nav-item__icon">
                <Icon name={icon} color="white" />
            </div>
            <div className="nav-item__name hide-nav-small">{label}</div>
        </div>
    );
}

export default MenuItem;
